function increase(max_val) {
  current_qty = $('.input-number').val()
  new_qty = parseInt(current_qty) + 1
  
  if (new_qty > max_val){
    new_qty = max_val
  }
  if (new_qty < 1){
    new_qty = 1
  }
  if (isNaN(new_qty)){
  	new_qty = 1
  }
  $('#quantity_input').val(new_qty);
}

function decrease(max_val) {
  current_qty = $('.input-number').val()
  new_qty = parseInt(current_qty) - 1
  if (new_qty > max_val){
    new_qty = max_val
  }
  if (isNaN(new_qty)){
  	new_qty = 1
  }
    if (new_qty < 1){
    new_qty = 1
  }
  $('#quantity_input').val(new_qty);
 
}

function checkValidIP(){
  var r = new RegExp("[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}");
  let custom_ip = document.getElementsByClassName("custom_ip");
  let custom_remote = document.getElementsByClassName("custom_remote");
  if (custom_ip.length > 0 ){
    custom_ip = custom_ip[0]
    if (custom_ip.value != "" && !(r.test(custom_ip.value))){
    	return false; 
    }
  }
  if (custom_remote.length > 0){
    custom_remote = custom_remote[0]
    if (custom_remote.value != "" && !(r.test(custom_remote.value))){
    	return false; 
    }
  }
  return true;
}

function qty_box_input(max_val) {
current_qty = $('.input-number').val()
  new_qty = parseInt(current_qty)
  if (new_qty > max_val){
    new_qty = max_val
  }  

  if (isNaN(new_qty)){
  	new_qty = 1
  }
   if (new_qty < 1){
    new_qty = 1
  }
  $('#quantity_input').val(new_qty);
}

async function reportRecdATC(recd, currSku) {
  /**
  @description:
  @param {string} recd - The SKU of the reffering recommended product.
  @param {string} currSku - The current SKU of the product.
  **/
  const id = localStorage.getItem("lsid");


  const customerId =  localStorage.getItem('lsid');
  const reqUrl = new URL('https://apiapi.ombligo.com/thompsonRecs');
  
  const payload = {
    sku: recd,
    clicked_sku: currSku,
    user_id: customerId ? `${customerId}` : null,
    recd: recd,
  };

  try {
    const response = await fetch(reqUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

  } catch (error) {
    console.error('Error reporting clicked recommendation:', error);
  }
}

function UpdateCartCountInNav(qty = 1) {
    let CartCountInNav = document.getElementById('cartCount');
    let CurrentCount = 0;
    let AmntToAdd = parseInt(qty) || 1; 

    if (CartCountInNav) {
        CurrentCount = parseInt(CartCountInNav.innerText) || 0;
        CartCountInNav.innerText = CurrentCount + AmntToAdd;
    }
  }


function CartManager(fn = 'add', id = null, qty = 1, inventory_quantity = 999) {

  if (!id) return;
  if (qty <= 0) {
    console.error('Quantity must be greater than zero');
    return;
  }

  let CartSession = sessionStorage.getItem('cart') ? JSON.parse(sessionStorage.getItem('cart')) : {};

  if (fn === 'add') {
    if (!CartSession[id]) {
      if (qty <= inventory_quantity) {
        CartSession[id] = { quantity: 0, properties: {} };
      }
    }
    CartSession[id].quantity = parseInt(CartSession[id].quantity) + parseInt(qty);
  }
  else if (fn === 'remove') {
    if (CartSession[id]) {
      CartSession[id].quantity -= qty;
      if (CartSession[id].quantity <= 0) {
        delete CartSession[id];
      }
    }
  }
  else if (fn === 'update') {
    if (CartSession[id]) {
      CartSession[id].quantity = qty;
    }
  }

  sessionStorage.setItem('cart', JSON.stringify(CartSession));
  console.log('Cart updated:', CartSession);
  return CartSession;

}


function add_to_cart(id, inventory_quantity=999, title="", prod_sku=false, os_ip=false, remote_ip=false, expedited=false, warranty_id=false, warranty_text="", server_serial="") {
  /**
  @description: 
  @param {} 
  **/



  if (server_serial === "noSerial") return;

  let warranty_select = document.getElementById("warranty"), 
      qty             = $('.input-number').val(), 
      expedited_chkbx = null; 
      // if (warranty_select && warranty_select.selectedIndex == 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'Missing Warranty',
      //     text: 'Please select a valid warranty option'
      //   });
      //   return; 
      // }
      
      if (!(checkValidIP())) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid IP',
          text: 'The IP entered is invalid.'
        });
        return; 
      }
  // setLoadingOverlay("product-template-anchor"); // NOTE unlcear of what this fn does 

  let CartSession = CartManager('add', id, qty, inventory_quantity);
  console.log('Cart Session:', CartSession);
  console.log('Adding to cart:', id, 'with quantity:', qty);
  console.log('Inventory quantity:', inventory_quantity);
  if (CartSession[id].quantity > inventory_quantity) {
    Swal.fire({
      title: 'Quantity Exceeded',
      text: `You can only add up to ${inventory_quantity} of this item to your cart.`,
      icon: 'warning',
      showCancelButton: true,
      showDenyButton: true,
      showConfirmButton: true,
      cancelButtonText: "OK",
      denyButtonText: "Request a Quote",
      confirmButtonText: `Checkout with the ${inventory_quantity} items now`,
      customClass: {
        cancelButton: "swal-btn-cancel ",
        denyButton: "swal-btn-confirm swal-btn-confirm-forced",
        confirmButton: "swal-btn-confirm "
      }
    }).then(function(result) {
      if (result.isConfirmed) {
        window.location.href = '/checkout';
      }
      else if (result.isDenied) {
        window.location.href = '/pages/contact' + '?rfq=' + encodeURIComponent(title );
      }
    });
    return;
  }


  if ($(".custom_ip").val()) custom_os_ip         = $(".custom_ip").val().trim()
  if ($(".custom_remote").val()) custom_remote_ip = $(".custom_remote").val().trim(); 

  expedited_chkbx = document.getElementById("expedited-chkbx"); // expedidted shipping checkbox 
  if (server_serial != "") {
    cartAPI('POST', id, qty, [['Server Serial', server_serial]]);
    added2CartModalMsg(product_collections.has("Hard Drives"))
    return;
  }
  if (expedited_chkbx !== null && expedited_chkbx.checked) cartAPI('POST', expedited, qty, [['Server SKU', prod_sku]]); 
  if (warranty_id) cartAPI('POST', warranty_id, qty, [['Server SKU', prod_sku], ['Warranty', warranty_text]]); 
  
  jQuery.getJSON('/cart.js', () => {
    warranty_id ? cartAPI('POST', id, qty, [['Server SKU', prod_sku], ['Warranty', warranty_text]]) : cartAPI('POST', id, qty);
  });
  
  if (typeof custom_os_ip !== 'undefined' && custom_os_ip != '' ) cartAPI('POST', os_ip, qty, [['Server SKU', prod_sku], ['IP', custom_os_ip]])		
  if (typeof custom_remote_ip !== 'undefined' && custom_remote_ip != '' ) cartAPI('POST', remote_ip, qty, [['Server SKU', prod_sku], ['IP', custom_remote_ip]]); 

  // removeLoadingOverlay();
  added2CartModalMsg(product_collections.has("Hard Drives"))
  const currUrl = new URL(window.location.href);
  if (currUrl.searchParams.has('recd')) {
    const recd = currUrl.searchParams.get('recd');
     reportRecdATC(recd, productSKU);
  }


  UpdateCartCountInNav(qty);

}


function added2CartModalMsg(hardDrives=false) {
  /**
  @description: 
  @param {} 
  **/
  let msgObj = {
    title: "Added to Cart",
    icon: "success",
    showCancelButton: true,
    confirmButtonText: "Go to Cart",
    cancelButtonText: "Continue Shopping",
    customClass: {
      cancelButton: "swal-btn-cancel",
      confirmButton: "swal-btn-confirm"
    }
  };

  if (hardDrives) {
    msgObj['text'] = "This hard drive does not include a caddy. Want to view our caddies now?";
    msgObj.showDenyButton = true;
    msgObj.denyButtonText = "View Caddies";
    msgObj.customClass.denyButton = "swal-btn-confirm";

    Swal.fire(msgObj).then((result) => {
      if (result.isConfirmed) {
        window.location.href = '/cart';
      } else if (result.isDenied) {
        window.location.href = '/collections/caddies';
      }
    });
  } else {
    Swal.fire(msgObj).then((result) => {
      if (result.isConfirmed) {
        window.location.href = '/cart';
      }
    });
  }
}



function cartAPI(RESTtype, warranty_id, qty, args=[]) {
  /**
  @description: 
  @param {} 
  **/
  let data2Send = {
    id          : warranty_id,
    quantity    : qty,
    properties  : {}
  }
  
  for (var pair of args) {
    data2Send.properties[pair[0]] = pair[1]
  }

  $.ajax({
    type    : RESTtype,
    async   : false,
    url     : '/cart/add.js',
    data    : jQuery.param(data2Send),
    success : data => {
      return; 
    },
    error   : data => {
      console.log(data); 
      return; 
    }
  });
}


function change_gift_id() {
  const selected = document.querySelector("#gift-card-select option:checked");
  const selectedId = selected.id;
  const selectedTitle = selected.innerText;
  document.querySelector("#AddToCart-product-template").setAttribute("onclick", `addGiftCardToCart(${selectedId})`);
  document.querySelector("#prodPrice").innerText = selectedTitle;
}



function processing_disclaimer(){
  Swal.fire({
    icon: 'info',
    title: 'Expedited Processing',
    text: 'For orders placed before 1PM EST, expedited processing ensures same-day shipping. Should your order not ship on the same day, your rush processing fee will be refunded.'
  });}



function check3DImageExists(imageSrc) {
  var img = new Image();
  img.onload = () => {
  	$("#3d-btn").removeClass("invisible"); 
  };
  img.src = imageSrc;
  
}



function view3DModel(){

    let o = document.getElementById("overlay-bg");
    o.style.display = "block";
  	o.addEventListener("click", function(){
      this.style.display = "none";
    });
  
  	let a = document.getElementById("3d-model");
  	a.addEventListener("click", function(){
      event.stopPropagation();
    });
}

